import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { map } from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { List, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { currentAssetSliceActions } from "../../../Store/Slices/CurrentAssetSlice";
import Slider from "@mui/material/Slider";
import { unicodeToString } from "../../../Js/Common";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import OptionMedia from "../../../Components/Card/AssetUI/OptionMedia";
import StatusIndicator from "../../../Components/Card/AssetUI/StatusIndicator";

var initLogObj = {
  attempts: 1,
  duration: 0,
  assetType: {
    group: "practice",
    value: null,
  },
  userAnswer: [],
  isEvaluated: "auto",
  actualAnswer: [],
  genericScore: 0,
};

const IE = (props) => {
  // Hooks
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  let [userAnswer, setUserAnswer] = useState([]);
  let [logObj, setLogObj] = useState(initLogObj);
  let [options, setOptions] = useState([]);
  let [currentOption, setCurrentOption] = useState(0);
  let [currentOptionLocation, setCurrentOptionLocation] = useState(0);
  let [wordSplit, setWordSplit] = useState(false);
  let [ltrSpace, setLtrSpace] = useState(1);
  let [anchorEl, setAnchorEl] = useState(null);
  let [currentIndexPlay, setCurrentIndexPlay] = useState([]);
  let open = Boolean(anchorEl);

  // Redux state
  const { showAnswer, assetLogObj, attempted, currentAttempt, optionWiseAns } =
    useSelector((state) => state.currentAsset);

  useEffect(() => {
    if (props.content) {
      console.log("props.content", props.content);
      setWordSplit(props.content.epage.options.splitByWords);
      let splitContent = [];
      let actualAnswers = [];
      props.content.epage.options.content.map((val, index) => {
        let arr = getWordsOrLtr(
          unicodeToString(val.text),
          props.content.epage.options.splitByWords
        );
        splitContent.push(arr);
        let actualAns = [];
        val.answer.possibilities.map((ans, index1) => {
          actualAns.push(unicodeToString(ans).trim());
        });
        actualAnswers.push(actualAns);
      });
      console.log("***********************", splitContent);
      setOptions(splitContent);
      setUserAnswer(
        new Array(props.content.epage.options.content.length).fill(null)
      );
      dispatch(
        currentAssetSliceActions.setCurrentAttemptData(
          new Array(props.content.epage.options.content.length).fill(null)
        )
      );
      setLogObj({
        ...logObj,
        assetType: {
          ...logObj.assetType,
          value: props.content.info.asset_type_alias,
        },
        actualAnswer: actualAnswers,
      });
    }
  }, [props.content]);

  useEffect(() => {
    dispatch(currentAssetSliceActions.setAssetLogObj(logObj));
    dispatch(currentAssetSliceActions.setShowAnswer(false));
  }, [logObj]);

  useEffect(() => {
    setUserAnswer(
      new Array(props.content.epage.options.content.length).fill(null)
    );
    dispatch(currentAssetSliceActions.setShowAnswer(false));
    dispatch(
      currentAssetSliceActions.setCurrentAttemptData(
        new Array(props.content.epage.options.content.length).fill(null)
      )
    );
    let splitContent = [];
    props.content.epage.options.content.map((val, index) => {
      let arr = getWordsOrLtr(
        unicodeToString(val.text),
        props.content.epage.options.splitByWords
      );
      splitContent.push(arr);
    });
    setOptions(splitContent);
  }, [currentAttempt]);

  useEffect(() => {
    if (showAnswer && assetLogObj && assetLogObj.actualAnswer) {
      console.log("assetLogObj.actualAnswer", assetLogObj.actualAnswer);
      setUserAnswer(assetLogObj.actualAnswer);
    }
  }, [showAnswer, assetLogObj]);

  useEffect(() => {
    return () => {
      setUserAnswer([]);
    };
  }, []);

  const getWordsOrLtr = (text, wordSplitParam) => {
    let arr = [];
    if (wordSplitParam) {
      arr = text.split(" ");
    } else {
      arr = text.split("");
    }
    let newArr = [];
    arr.forEach((val, ind) => {
      newArr.push({
        text: val,
        blank: false,
      });
      newArr.push({
        text: "&nbsp;",
        blank: true,
      });
    });

    return newArr;
  };

  const openPopup = (event, index, index1) => {
    if (!showAnswer && !attempted) {
      setAnchorEl(event.currentTarget);
      setCurrentOption(index);
      setCurrentOptionLocation(index1);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const insertEl = (text) => {
    setAnchorEl(null);
    let arr = [...options];
    arr[currentOption][currentOptionLocation]["text"] = text;
    setOptions(arr);
    console.log("arr[currentOption]", arr[currentOption]);
    updateUserAnswer(arr[currentOption]);
  };

  const removeEl = () => {
    setAnchorEl(null);
    let arr = [...options];
    arr[currentOption][currentOptionLocation]["text"] = "&nbsp;";
    setOptions(arr);
    updateUserAnswer(arr[currentOption]);
  };

  let updateUserAnswer = (arr) => {
    let allText = map(arr, "text");
    let actualText = allText.filter((val, ind) => {
      if (val != "&nbsp;") return val;
    });
    let arr1 = [...userAnswer];
    if (wordSplit) {
      arr1[currentOption] = actualText.join(" ");
    } else {
      arr1[currentOption] = actualText.join("");
    }
    setUserAnswer(arr1);
    dispatch(currentAssetSliceActions.setCurrentAttemptData(arr1));
  };

  const setPlayMode = (status, index, end) => {
    if (status == true && !end && !currentIndexPlay[index]) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (currentIndexPlay[index] || end) {
      let arr = new Array(props.content.epage.options.content.length).fill(
        false
      );
      setCurrentIndexPlay(arr);
    }
  };

  return (
    <Box sx={{ position: "relative", height: "64vh", overflow: "auto" }}>
      {props.content && !showAnswer && (
        <Box
           
          sx={{ mt: 1, height: "64vh", overflow: "auto" }}
        >
          {props.content.epage.options.content.map((val, index) => {
            return (
              <Box sx={{ display: "inline-flex", width: "100%", mt: 1 }}>
                {optionWiseAns && optionWiseAns.length > 0 && (
                  <StatusIndicator
                    correct={optionWiseAns[index]}
                  ></StatusIndicator>
                )}
                {val && val.media && (
                  <OptionMedia
                    media={val.media}
                    isPlaying={currentIndexPlay[index]}
                    setPlayMode={(status, end) => {
                      setPlayMode(status, index, end);
                    }}
                  ></OptionMedia>
                )}
                <Typography
                  color="primary.main"
                  sx={{
                    fontWeight: "500",
                    fontSize: "0.9rem",
                    letterSpacing: "0.1rem",
                    borderBottom: 1,
                    borderBottomColor: "#EAECEE",
                    my: 1,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.6rem",
                    },
                  }}
                >
                  {options[index] &&
                    options[index].map((obj, index1) => {
                      return (
                        <>
                          {!obj.blank && (
                            <span
                              style={{
                                display: "inline-block",
                                padding: `0 ${
                                  wordSplit
                                    ? 5 + +ltrSpace * 0.04
                                    : 2 + +ltrSpace * 0.04
                                }px`,
                              }}
                            >
                              {obj.text}
                            </span>
                          )}
                          {obj.blank && (
                            <span
                              aria-controls={open ? "basic-menu" : undefined}
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                              onClick={(ev) => {
                                openPopup(ev, index, index1);
                              }}
                              style={
                                obj.text == "&nbsp;"
                                  ? {}
                                  : {
                                      backgroundColor: "#ccc",
                                      display: "inline-block",
                                    }
                              }
                            >
                              {obj.text == "&nbsp;" ? `\u00A0` : obj.text}
                            </span>
                          )}
                        </>
                      );
                    })}
                </Typography>
              </Box>
            );
          })}
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            {props.content.epage.options.content[currentOption].answer &&
              options[currentOption] &&
              options[currentOption][currentOptionLocation] &&
              options[currentOption][currentOptionLocation].text == "&nbsp;" &&
              props.content.epage.options.content[
                currentOption
              ].answer.option_collection.map((opt, index2) => {
                return (
                  <MenuItem
                    className="font_1_4"
                    onClick={() => {
                      insertEl(unicodeToString(opt).trim(), index2);
                    }}
                  >
                    {unicodeToString(opt).trim()}
                  </MenuItem>
                );
              })}
            {props.content.epage.options.content[currentOption].answer &&
              options[currentOption] &&
              options[currentOption][currentOptionLocation] &&
              options[currentOption][currentOptionLocation].text !=
                "&nbsp;" && (
                <MenuItem
                  onClick={() => {
                    removeEl();
                  }}
                >
                  Remove
                </MenuItem>
              )}
          </Menu>
        </Box>
      )}
      {props.content && showAnswer && userAnswer && (
        <Box sx={{ mt: 2 }}>
          {userAnswer.map((actAns, index3) => {
            return (
              <Typography
                color="primary.main"
                sx={{
                  fontWeight: "500",
                  fontSize: "0.9rem",
                  letterSpacing: "0.1rem",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.6rem",
                  },
                  borderBottom: 1,
                  borderBottomColor: "#EAECEE",
                  lineHeight: "2rem",
                }}
              >
                {actAns ? [...actAns].join(" | ") : ""}
              </Typography>
            );
          })}
        </Box>
      )}
      {!showAnswer && (
        <Slider
          sx={{
            position: "absolute",
            bottom: "0rem",
            width: "100%",
            "@media (min-width: 1636px)": {
              bottom: "10rem",
            },
          }}
          size="small"
          defaultValue={1}
          onChange={(val) => {
            setLtrSpace(+val.target.value);
          }}
          aria-label="Small"
          valueLabelDisplay="auto"
        />
      )}
    </Box>
  );
};
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem !important",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default IE;
